var render = function render(){var _vm=this,_c=_vm._self._c;return _c('interview-panel-jobs',{attrs:{"type":"fullwidth"}})
}
var staticRenderFns = []

export { render, staticRenderFns }